import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import {
    AvatarPresence,
    AvatarSize,
    AvatarSizes,
    AvatarVariant,
    AvatarVariants,
} from '@dxp/core/types';
import { InitialsPipe } from '@dxp/core/pipes';

@Component({
    selector: 'telxl-avatar',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, InitialsPipe],
    templateUrl: './avatar.component.html',
    styleUrl: './avatar.component.scss',
})
export class TelXLAvatarComponent {
    name = input<string | undefined | null>('');
    icon = input<string>('');
    presence = input<AvatarPresence>();
    variant = input<AvatarVariant>(AvatarVariants.Default);
    size = input<AvatarSize>(AvatarSizes.Large);

    presenceClass = computed<string | undefined>(() =>
        this.presence() ? `bg-${this.presence()}` : undefined,
    );

    hasIcon = computed(() => this.icon()?.trim().length > 0);
    displayName = computed<string>(
        () => (this.name() ? this.name() : '?') as string,
    );
}
